export const DYNAMISCHE_ABWESENHEIT_ARTEN = {
  tagesschnitt: 'tagesschnitt',
  wochenschnitt: 'wochenschnitt',
  drei_monatsschnitt: 'drei_monatsschnitt',
  '12_monatsschnitt': '12_monatsschnitt',
} as const;

export type DynamischeAbwesenheitArt =
  keyof typeof DYNAMISCHE_ABWESENHEIT_ARTEN;
